// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.l3zqI9 {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  font-family: 'Source Sans 3', sans-serif;
}

._I6nUd {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 300px; /* Permite que o flex item encolha */
}

.pOKDDc {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  gap: 24px;
  width: 100%;
  padding: 0;
  background-color: transparent;
  border-radius: 0;
}

.Mp2iBN {
  font-weight: 600;
  font-size: 14px;
  line-height: 1.8;
  color: #1f1f1f;
  flex: 1;
  min-height: 25px;
  display: flex;
  align-items: center;
  font-family: 'Source Sans 3', sans-serif;
}

.AFhGMC {
  display: flex;
  align-items: center;
  position: relative;
  background: var(--surface-neutral-pale);
  border: 1px solid var(--stroke-neutral-silver);
  border-radius: var(--radius-s);
  height: 36px;
  width: 304px;
}

.DKliQH {
  flex-shrink: 0;
}

.li0osF {
  width: 304px;
}

.li0osF .input-container {
  background-color: #fafafa !important;
  border: 1px solid #cccccc !important;
  border-radius: 4px !important;
  padding: 8px 12px !important;
}

.li0osF .input {
  background-color: transparent !important;
  border: none !important;
  font-size: 12px !important;
  line-height: 1.424 !important;
  color: #1f1f1f !important;
  font-weight: 400 !important;
}

.li0osF .input::placeholder {
  color: #999999 !important;
  font-size: 12px !important;
  font-weight: 400 !important;
}

.Y5clOM {
  color: #666666;
  width: 16px;
  height: 16px;
}

.FAhQth,
.wlZiCH {
  padding: 12px 16px;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1.4;
  font-weight: 400;
}

.FAhQth {
  background-color: #ffeee5;
  color: #d64000;
  border: 1px solid #d64000;
}

.wlZiCH {
  background-color: #ffeee5;
  color: #1f1f1f;
  border: 1px solid #d64000;
}

.b2ZZRL {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 317px;
  overflow-y: auto;
  padding-right: 4px;
}

.b2ZZRL::-webkit-scrollbar {
  width: 1px;
}

.b2ZZRL::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.b2ZZRL::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.b2ZZRL::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.ZsiXdr {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.dWNT3P {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.wR9PDE {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.42;
  color: #1f1f1f;
}

.EWuHu6 {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.42;
  color: #1f1f1f;
  margin-left: auto;
}

.CWg2rN {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 16px;
}

.FG0vL3 {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  gap: 16px;
  padding: 16px;
  background: var(--surface-neutral-pale, #fafafa);
  border-radius: 4px;
  width: 100%;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  height: 74px;
}

.FG0vL3:hover {
  transform: translateY(-2px);
}

.ryIwXT {
  background-color: #ffeee5;
}

.IWrRCy {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  height: 24px;
  flex-shrink: 0;
}

.pWTen5 {
  width: 16px;
  height: 16px;
  border: 1px solid #666666;
  border-radius: 50%;
  transition: all 0.2s ease;
  background-color: transparent;
}

.Q8hbqk {
  border-color: #d64000;
  background-color: #d64000;
  position: relative;
}

.Q8hbqk::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 6px;
  height: 6px;
  background-color: #ffffff;
  border-radius: 50%;
}

.qsT3iF {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 2px;
  min-width: 0;
}

.ebgmEE {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.8;
  color: #1f1f1f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cJAEEd {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.8;
  color: #1f1f1f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.o3suG1 {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.s4AkDw,
.S0HOdz {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.s4AkDw:hover,
.S0HOdz:hover {
  background-color: #ffeee5;
  transform: scale(1.1);
}

.cDxtjM {
  color: #d64000;
}

.Og3yAJ,
.sz47gE {
  width: 16px;
  height: 16px;
  color: #d64000;
}

.FXlXNc,
.rdExCP {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
}

.NasU59 {
  width: 72px;
  height: 72px;
}

.eSIfWw {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 270px;
  gap: 16px;
}
.s7tsFU {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.8;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: var(--text-neutral-dark, #1f1f1f);
}

.JShjwK {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.8;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  color: var(--text-neutral-dark, #1f1f1f);
}

.rdExCP {
  color: #666666;
  font-size: 14px;
}

.j3JcBf {
  width: 24px;
  height: 24px;
  border: 2px solid #e0e0e0;
  border-top: 2px solid #d64000;
  border-radius: 50%;
  animation: ZnbYTw 1s linear infinite;
}

@keyframes ZnbYTw {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.jqfEXK {
  padding: 24px;
  text-align: center;
  color: #999999;
  font-size: 14px;
  background-color: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

@media (max-width: 768px) {
  .pOKDDc {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    padding: 0;
  }

  .DKliQH {
    width: 100%;
  }

  .li0osF {
    width: 100%;
  }

  .ZsiXdr {
    padding: 12px 16px;
  }

  .CWg2rN {
    flex-direction: column;
    gap: 12px;
  }

  .FG0vL3 {
    max-width: 100%;
    padding: 12px;
    gap: 12px;
  }

  .o3suG1 {
    gap: 4px;
  }

  .s4AkDw,
  .S0HOdz {
    width: 28px;
    height: 28px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/SelectContact/SelectContact.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;EACP,iBAAiB,EAAE,oCAAoC;AACzD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,UAAU;EACV,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uCAAuC;EACvC,8CAA8C;EAC9C,8BAA8B;EAC9B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,gDAAgD;EAChD,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,aAAa;IACb,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n  font-family: 'Source Sans 3', sans-serif;\n}\n\n.loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  min-height: 300px; /* Permite que o flex item encolha */\n}\n\n.header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n  gap: 24px;\n  width: 100%;\n  padding: 0;\n  background-color: transparent;\n  border-radius: 0;\n}\n\n.headerLabel {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.8;\n  color: #1f1f1f;\n  flex: 1;\n  min-height: 25px;\n  display: flex;\n  align-items: center;\n  font-family: 'Source Sans 3', sans-serif;\n}\n\n.searchInputContainer {\n  display: flex;\n  align-items: center;\n  position: relative;\n  background: var(--surface-neutral-pale);\n  border: 1px solid var(--stroke-neutral-silver);\n  border-radius: var(--radius-s);\n  height: 36px;\n  width: 304px;\n}\n\n.searchContainer {\n  flex-shrink: 0;\n}\n\n.searchInput {\n  width: 304px;\n}\n\n.searchInput :global(.input-container) {\n  background-color: #fafafa !important;\n  border: 1px solid #cccccc !important;\n  border-radius: 4px !important;\n  padding: 8px 12px !important;\n}\n\n.searchInput :global(.input) {\n  background-color: transparent !important;\n  border: none !important;\n  font-size: 12px !important;\n  line-height: 1.424 !important;\n  color: #1f1f1f !important;\n  font-weight: 400 !important;\n}\n\n.searchInput :global(.input::placeholder) {\n  color: #999999 !important;\n  font-size: 12px !important;\n  font-weight: 400 !important;\n}\n\n.searchIcon {\n  color: #666666;\n  width: 16px;\n  height: 16px;\n}\n\n.warningMessage,\n.successMessage {\n  padding: 12px 16px;\n  border-radius: 4px;\n  font-size: 14px;\n  line-height: 1.4;\n  font-weight: 400;\n}\n\n.warningMessage {\n  background-color: #ffeee5;\n  color: #d64000;\n  border: 1px solid #d64000;\n}\n\n.successMessage {\n  background-color: #ffeee5;\n  color: #1f1f1f;\n  border: 1px solid #d64000;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 317px;\n  overflow-y: auto;\n  padding-right: 4px;\n}\n\n.content::-webkit-scrollbar {\n  width: 1px;\n}\n\n.content::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 3px;\n}\n\n.content::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 3px;\n}\n\n.content::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n.section {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.sectionHeader {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n}\n\n.sectionTitle {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.42;\n  color: #1f1f1f;\n}\n\n.sectionCount {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.42;\n  color: #1f1f1f;\n  margin-left: auto;\n}\n\n.contactsList {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  gap: 16px;\n}\n\n.contactItem {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n  gap: 16px;\n  padding: 16px;\n  background: var(--surface-neutral-pale, #fafafa);\n  border-radius: 4px;\n  width: 100%;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n  height: 74px;\n}\n\n.contactItem:hover {\n  transform: translateY(-2px);\n}\n\n.contactItemSelected {\n  background-color: #ffeee5;\n}\n\n.contactItemRadio {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.radioButton {\n  width: 16px;\n  height: 16px;\n  border: 1px solid #666666;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n  background-color: transparent;\n}\n\n.radioButtonSelected {\n  border-color: #d64000;\n  background-color: #d64000;\n  position: relative;\n}\n\n.radioButtonSelected::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 6px;\n  height: 6px;\n  background-color: #ffffff;\n  border-radius: 50%;\n}\n\n.contactItemContent {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  gap: 2px;\n  min-width: 0;\n}\n\n.contactItemName {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.8;\n  color: #1f1f1f;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.contactItemKey {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.8;\n  color: #1f1f1f;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.contactItemActions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.favoriteButton,\n.deleteButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.favoriteButton:hover,\n.deleteButton:hover {\n  background-color: #ffeee5;\n  transform: scale(1.1);\n}\n\n.favoriteButtonActive {\n  color: #d64000;\n}\n\n.favoriteIcon,\n.deleteIcon {\n  width: 16px;\n  height: 16px;\n  color: #d64000;\n}\n\n.emptyState,\n.loadingState {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  text-align: center;\n}\n\n.emptyStateIcon {\n  width: 72px;\n  height: 72px;\n}\n\n.emptyStateContent {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  max-width: 270px;\n  gap: 16px;\n}\n.emptyStateTitle {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.8;\n  letter-spacing: 0%;\n  text-align: center;\n  vertical-align: middle;\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.emptyStateMessage {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.8;\n  letter-spacing: 0px;\n  text-align: center;\n  vertical-align: middle;\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.loadingState {\n  color: #666666;\n  font-size: 14px;\n}\n\n.loadingSpinner {\n  width: 24px;\n  height: 24px;\n  border: 2px solid #e0e0e0;\n  border-top: 2px solid #d64000;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.disabledMessage {\n  padding: 24px;\n  text-align: center;\n  color: #999999;\n  font-size: 14px;\n  background-color: #fafafa;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n}\n\n@media (max-width: 768px) {\n  .header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n    padding: 0;\n  }\n\n  .searchContainer {\n    width: 100%;\n  }\n\n  .searchInput {\n    width: 100%;\n  }\n\n  .section {\n    padding: 12px 16px;\n  }\n\n  .contactsList {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .contactItem {\n    max-width: 100%;\n    padding: 12px;\n    gap: 12px;\n  }\n\n  .contactItemActions {\n    gap: 4px;\n  }\n\n  .favoriteButton,\n  .deleteButton {\n    width: 28px;\n    height: 28px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `l3zqI9`,
	"loader": `_I6nUd`,
	"header": `pOKDDc`,
	"headerLabel": `Mp2iBN`,
	"searchInputContainer": `AFhGMC`,
	"searchContainer": `DKliQH`,
	"searchInput": `li0osF`,
	"searchIcon": `Y5clOM`,
	"warningMessage": `FAhQth`,
	"successMessage": `wlZiCH`,
	"content": `b2ZZRL`,
	"section": `ZsiXdr`,
	"sectionHeader": `dWNT3P`,
	"sectionTitle": `wR9PDE`,
	"sectionCount": `EWuHu6`,
	"contactsList": `CWg2rN`,
	"contactItem": `FG0vL3`,
	"contactItemSelected": `ryIwXT`,
	"contactItemRadio": `IWrRCy`,
	"radioButton": `pWTen5`,
	"radioButtonSelected": `Q8hbqk`,
	"contactItemContent": `qsT3iF`,
	"contactItemName": `ebgmEE`,
	"contactItemKey": `cJAEEd`,
	"contactItemActions": `o3suG1`,
	"favoriteButton": `s4AkDw`,
	"deleteButton": `S0HOdz`,
	"favoriteButtonActive": `cDxtjM`,
	"favoriteIcon": `Og3yAJ`,
	"deleteIcon": `sz47gE`,
	"emptyState": `FXlXNc`,
	"loadingState": `rdExCP`,
	"emptyStateIcon": `NasU59`,
	"emptyStateContent": `eSIfWw`,
	"emptyStateTitle": `s7tsFU`,
	"emptyStateMessage": `JShjwK`,
	"loadingSpinner": `j3JcBf`,
	"spin": `ZnbYTw`,
	"disabledMessage": `jqfEXK`
};
module.exports = ___CSS_LOADER_EXPORT___;
